import React, { useState } from 'react';
import { Box, Typography, Button, Alert, Snackbar } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { format } from 'date-fns';
import TransactionShortTable from './TransactionShortTable';
import TransactionWorkTable from './TransactionWorkTable';
import api from '../../services/api';

const initialWorkRows = [
  { name: '' },
  { name: '' },
  { name: '' },
  { name: '' },
  { name: '' },
  { name: 'Setting' },
  { name: 'Polish' },
  { name: 'Cutting' },
  { name: 'Galai' },
  { name: '' },
];

const TransactionOther1 = () => {
  const [workRows, setWorkRows] = useState(initialWorkRows);
  const [shortTableValues, setShortTableValues] = useState(Array(7).fill(''));
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [saveError, setSaveError] = useState('');
  const currentDate = new Date();

  const handleWorkTableChange = (rowIdx, field, value) => {
    setWorkRows(rows => rows.map((row, idx) => idx === rowIdx ? { ...row, [field]: value } : row));
  };

  const handleShortTableChange = (idx, value) => {
    setShortTableValues(values => values.map((v, i) => i === idx ? value : v));
  };

  const handleSave = async () => {
    setSaveSuccess(false);
    setSaveError('');
    try {
      await api.post('/api/transaction/other1', {
        date: currentDate,
        shortTable: shortTableValues,
        workTable: workRows
      });
      setSaveSuccess(true);
    } catch (err) {
      setSaveError('Failed to save transaction');
    }
  };

  return (
    <Box sx={{ mt: 8, px: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => window.history.back()} variant="outlined" color="primary" sx={{ mr: 2 }}>
          Back
        </Button>
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          <Typography variant="h6" sx={{ textAlign: 'right' }}>
            Date: {format(currentDate, 'dd/MM/yyyy')}
          </Typography>
        </Box>
      </Box>
      <TransactionShortTable rightCells={shortTableValues} onChange={handleShortTableChange} />
      <TransactionWorkTable rows={workRows} onChange={handleWorkTableChange} />
      <Box sx={{ mt: 2, textAlign: 'right' }}>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Save Transaction
        </Button>
      </Box>
      <Snackbar open={!!saveError} autoHideDuration={4000} onClose={() => setSaveError('')} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={() => setSaveError('')} severity="error" sx={{ width: '100%' }}>
          {saveError}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default TransactionOther1; 